import { Controller } from "@hotwired/stimulus"

const FULLSCREEN_CLASSES = ["h-dvh", "flex", "flex-col", "lg:h-auto", "lg:block"]

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon", "toggleButton"]

  toggle() {
    this.#setExpanded(this.menuTarget.classList.contains("hidden"))
  }

  close() {
    this.#setExpanded(false)
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  #setExpanded(expanded) {
    this.menuTarget.classList.toggle("hidden", !expanded)
    this.openIconTarget.classList.toggle("hidden", expanded)
    this.closeIconTarget.classList.toggle("hidden", !expanded)
    FULLSCREEN_CLASSES.forEach(className => this.element.classList.toggle(className, expanded))
    document.body.classList.toggle("overflow-hidden", expanded)
    this.toggleButtonTarget.setAttribute("aria-expanded", expanded)
    this.toggleButtonTarget.setAttribute("aria-label", expanded ? this.toggleButtonTarget.dataset.closeLabel : this.toggleButtonTarget.dataset.openLabel)
  }
}
